module.exports = __webpack_public_path__ + "img/p10.c7eb12c7.jpg";